import * as angular from 'angular';

export interface IImage {
    name: string;
    svg: string;
    png: string;
    folder: string;
    allowed_apps: Array<string>;
    description: string;
}

class IconService  {
    public images: Map<string, object> = new Map<string, object>();
    public fonts: Array<string> = [];
    public ready: Promise<any>;

    public static $inject = ['$http'];

    constructor($http) {
        this.ready = new Promise((resolve) => {
            const env = window.sps.$Constants.env === 'local' ? 'dev' : window.sps.$Constants.env;
            const iconJsonFile = window.sps.$Constants.appIcons + '/' + env + '.all-icons.json';
            const config = {
                headers: {
                    // This is needed to get around an oddity with S3 where it will not send a correct
                    // 'Vary' header to allow caching to work as expected with correct CORS headers, and
                    // Chrome will then try to fetch from cache and won't receive the right CORS headers at times
                    // and fail the request. Specifying that no cache should be used will always ensure we get this file from S3
                    // and allow the right headers to be sent to avoid any CORS issues and thus missing icons.
                    'Cache-Control': 'no-cache'
                }
            }
            $http.get(iconJsonFile, config).then((res) => {
                this.fonts = res.data.fonts;
                const images = res.data.images || [];
                images.forEach((image) => {
                    this.images.set(image.name, image);
                });
            }).finally(resolve);
        });
    }

    public whenReady() {
        return this.ready;
    }

    public getImage(name) {
        return this.images.get(name);
    }
}

export default angular
    .module('spsng.services.icon', [])
    .service('IconService', IconService)
    .name;
